export const ROUTE_VIEW_MAP = {
  '/WorkScheduleTable': 'work_schedule',
  '/DeliveryChallanTable': 'delivery_challan',
  '/DesignMixTable': 'design_mix',
  '/SalesOrderTable': 'sales_order',
  '/GoodsReceiptNoteTable': 'goods_receipt_note',
  '/ConsumptionNoteTable': 'consumption_note',
  '/DieselConsumptionTable': 'diesel_consumption',
  '/QuotationTable': 'quotation',
  '/PurchaseOrderTable': 'purchase_order',
  '/CheckInTable': 'check_in',
  '/SalesInvoiceTable': 'sales_invoice',
  '/CubeTestReportTable': 'cube_test_report',
  '/QcDeliveryChallanList': 'delivery_challan',
};

export const DATE_RANGE_OPTIONS = {
  today: { label: 'Today' },
  current_month: { label: 'Current Month' },
  last_two_months: { label: 'Last Two Months' },
  last_three_months: { label: 'Last Three Months' },
  custom: { label: 'Custom Date Range' },
};

export const RECORD_STATUS_OPTIONS = [
  { value: 'true', label: 'Active' },
  { value: 'false', label: 'Inactive' },
];

const STANDARD_DATE_OPTIONS = [
  { value: 'today', label: 'Today' },
  { value: 'current_month', label: 'Current Month' },
  { value: 'last_three_months', label: 'Last Three Months' },
  { value: 'custom', label: 'Custom Date Range' },
];

const STANDARD_TOOLBAR = ['today', 'current_month', 'last_three_months', 'custom'];

export const LIST_VIEW_SCHEMAS = {
  work_schedule: {
    sectionTitle: 'Work Schedule View',
    toolbarDateRanges: ['today', 'current_month', 'last_two_months', 'custom'],
    dateRangeOptions: [
      { value: 'today', label: 'Today' },
      { value: 'current_month', label: 'Current Month' },
      { value: 'last_two_months', label: 'Last Two Months' },
      { value: 'custom', label: 'Custom Date Range' },
    ],
    statusOptions: [
      { value: 'not_started', label: 'Not Started' },
      { value: 'in_progress', label: 'In-Progress' },
      { value: 'to_complete', label: 'To Complete' },
      { value: 'completed', label: 'Completed' },
    ],
    recordStatusOptions: RECORD_STATUS_OPTIONS,
  },
  delivery_challan: {
    sectionTitle: 'Delivery Challan View',
    toolbarDateRanges: STANDARD_TOOLBAR,
    dateRangeOptions: STANDARD_DATE_OPTIONS,
    recordStatusOptions: RECORD_STATUS_OPTIONS,
  },
  design_mix: {
    sectionTitle: 'Design Mix View',
    toolbarDateRanges: STANDARD_TOOLBAR,
    dateRangeOptions: STANDARD_DATE_OPTIONS,
    recordStatusOptions: RECORD_STATUS_OPTIONS,
  },
  sales_order: {
    sectionTitle: 'Sales Order View',
    toolbarDateRanges: STANDARD_TOOLBAR,
    dateRangeOptions: STANDARD_DATE_OPTIONS,
    recordStatusOptions: RECORD_STATUS_OPTIONS,
    showPlantFilter: false,
  },
  goods_receipt_note: {
    sectionTitle: 'Goods Receipt Note View',
    toolbarDateRanges: STANDARD_TOOLBAR,
    dateRangeOptions: STANDARD_DATE_OPTIONS,
    recordStatusOptions: RECORD_STATUS_OPTIONS,
  },
  consumption_note: {
    sectionTitle: 'Consumption Note View',
    toolbarDateRanges: STANDARD_TOOLBAR,
    dateRangeOptions: STANDARD_DATE_OPTIONS,
    recordStatusOptions: RECORD_STATUS_OPTIONS,
  },
  diesel_consumption: {
    sectionTitle: 'Diesel Consumption View',
    toolbarDateRanges: STANDARD_TOOLBAR,
    dateRangeOptions: STANDARD_DATE_OPTIONS,
    recordStatusOptions: RECORD_STATUS_OPTIONS,
  },
  quotation: {
    sectionTitle: 'Quotation View',
    toolbarDateRanges: STANDARD_TOOLBAR,
    dateRangeOptions: STANDARD_DATE_OPTIONS,
  },
  purchase_order: {
    sectionTitle: 'Purchase Order View',
    toolbarDateRanges: STANDARD_TOOLBAR,
    dateRangeOptions: STANDARD_DATE_OPTIONS,
  },
  check_in: {
    sectionTitle: 'Vehicle Check In View',
    toolbarDateRanges: STANDARD_TOOLBAR,
    dateRangeOptions: STANDARD_DATE_OPTIONS,
  },
  sales_invoice: {
    sectionTitle: 'Sales Invoice View',
    toolbarDateRanges: STANDARD_TOOLBAR,
    dateRangeOptions: STANDARD_DATE_OPTIONS,
    showCustomerFilter: true,
  },
  cube_test_report: {
    sectionTitle: 'Cube Test Report View',
    toolbarDateRanges: STANDARD_TOOLBAR,
    dateRangeOptions: STANDARD_DATE_OPTIONS,
    recordStatusOptions: RECORD_STATUS_OPTIONS,
  },
};

export const LIST_VIEW_SETTINGS_UPDATED_EVENT = 'listViewSettingsUpdated';

export function getDefaultListViewConfig(viewKey) {
  const schema = LIST_VIEW_SCHEMAS[viewKey];
  const config = {
    default_date_range: viewKey === 'sales_order' ? 'last_three_months' : 'current_month',
    record_statuses: ['true', 'false'],
    plant_ids: [],
    customer_ids: [],
    enabled_date_ranges: schema?.toolbarDateRanges || ['today', 'current_month', 'custom'],
    custom_from_date: null,
    custom_upto_date: null,
  };
  if (viewKey === 'work_schedule') {
    config.schedule_statuses = ['completed', 'to_complete', 'in_progress', 'not_started'];
  }
  return config;
}

export function dispatchListViewSettingsUpdated(viewKey) {
  window.dispatchEvent(new CustomEvent(LIST_VIEW_SETTINGS_UPDATED_EVENT, { detail: { viewKey } }));
}

export function getToolbarDateRanges(viewKey, config) {
  const schema = LIST_VIEW_SCHEMAS[viewKey];
  return config?.enabled_date_ranges?.length
    ? config.enabled_date_ranges
    : schema?.toolbarDateRanges || ['today', 'current_month', 'custom'];
}
